/*
*@Author: dcl
*@Description: 动态地图
*@Date: 2022-11-28 16:59:45
*/
<template>
<div ref="echarts" class="echarts-map">
</div>
<!-- <div class="map-title">东风南方保代23家分支机构分布图</div> -->
</template>

<script>
import * as echarts from 'echarts'
import dataJson from '../assets/china1.json'
export default {
    data() {
        return {
            //echart 配制option  
            options: {
                tooltip: {
                    triggerOn: "mousemove", //mousemove、click
                    padding: 8,
                    borderWidth: 1,
                    borderColor: '#409eff',
                    backgroundColor: 'rgba(255,255,255,0.7)',
                    textStyle: {
                        color: '#000000',
                        fontSize: 13
                    },
                    formatter: function (params) {
                        let res = ''
                        params.data && params.data.list && params.data.list.map(item => {
                            res += `${item.company}<br />地址：${item.address}<br />电话：${item.phone}<br />`
                        })
                        return res
                    }
                },
                geo: {
                    map: "china",
                    scaleLimit: {
                        min: 1.2,
                        max: 2
                    },
                    zoom: 1,
                    top: 100,
                    label: {
                        normal: {
                            show: true,
                            fontSize: "13",
                            color: "rgba(0,0,0,0.7)"
                            // color: '#ffffff'
                        },
                        emphasis: {
                            color: '#000000'
                        }
                    },
                    itemStyle: {
                        normal: {
                            areaColor: '#5a99ca',
                            borderColor: "rgba(255, 255, 255, 1)",
                            color: '#fff'
                        }
                    },
                    emphasis: {
                        itemStyle: {
                            areaColor: "none",
                            color: 'rgba(255,255,255,0.7)',
                        }
                    },
                    select: {
                        label: {
                            color: '#fff'
                        },
                        itemStyle: {
                            areaColor: '#207AC0',
                            color: "#fff"
                        },
                    },
                    regions: [{
                        name: '辽宁',
                        itemStyle: {
                            normal: {
                                areaColor: '#207AC0',
                                borderColor: '#4ecee6',
                                borderWidth: 1,
                                shadowColor: '#2c99f6',
                                shadowOffsetY: 0,
                                shadowBlur: 25
                            }
                        }
                    }, {
                        name: '北京',
                        itemStyle: {
                            normal: {
                                areaColor: '#207AC0',
                                borderColor: '#4ecee6',
                                borderWidth: 1,
                                shadowColor: '#2c99f6',
                                shadowOffsetY: 0,
                                shadowBlur: 25
                            }
                        }
                    }, {
                        name: '河北',
                        itemStyle: {
                            normal: {
                                areaColor: '#207AC0',
                                borderColor: '#4ecee6',
                                borderWidth: 1,
                                shadowColor: '#2c99f6',
                                shadowOffsetY: 0,
                                shadowBlur: 25
                            }
                        }
                    }, {
                        name: '山西',
                        itemStyle: {
                            normal: {
                                areaColor: '#207AC0',
                                borderColor: '#4ecee6',
                                borderWidth: 1,
                                shadowColor: '#2c99f6',
                                shadowOffsetY: 0,
                                shadowBlur: 25
                            }
                        }
                    }, {
                        name: '山东',
                        itemStyle: {
                            normal: {
                                areaColor: '#207AC0',
                                borderColor: '#4ecee6',
                                borderWidth: 1,
                                shadowColor: '#2c99f6',
                                shadowOffsetY: 0,
                                shadowBlur: 25
                            }
                        }
                    }, {
                        name: '江苏',
                        itemStyle: {
                            normal: {
                                areaColor: '#207AC0',
                                borderColor: '#4ecee6',
                                borderWidth: 1,
                                shadowColor: '#2c99f6',
                                shadowOffsetY: 0,
                                shadowBlur: 25
                            }
                        }
                    }, {
                        name: '上海',
                        itemStyle: {
                            normal: {
                                areaColor: '#207AC0',
                                borderColor: '#4ecee6',
                                borderWidth: 1,
                                shadowColor: '#2c99f6',
                                shadowOffsetY: 0,
                                shadowBlur: 25
                            }
                        }
                    }, {
                        name: '浙江',
                        itemStyle: {
                            normal: {
                                areaColor: '#207AC0',
                                borderColor: '#4ecee6',
                                borderWidth: 1,
                                shadowColor: '#2c99f6',
                                shadowOffsetY: 0,
                                shadowBlur: 25
                            }
                        }
                    }, {
                        name: '湖北',
                        itemStyle: {
                            normal: {
                                areaColor: '#207AC0',
                                borderColor: '#4ecee6',
                                borderWidth: 1,
                                shadowColor: '#2c99f6',
                                shadowOffsetY: 0,
                                shadowBlur: 25
                            }
                        }
                    }, {
                        name: '广东',
                        itemStyle: {
                            normal: {
                                areaColor: '#207AC0',
                                borderColor: '#4ecee6',
                                borderWidth: 1,
                                shadowColor: '#2c99f6',
                                shadowOffsetY: 0,
                                shadowBlur: 25
                            }
                        }
                    }, {
                        name: '四川',
                        itemStyle: {
                            normal: {
                                areaColor: '#207AC0',
                                borderColor: '#4ecee6',
                                borderWidth: 1,
                                shadowColor: '#2c99f6',
                                shadowOffsetY: 0,
                                shadowBlur: 25
                            }
                        }
                    }, {
                        name: '重庆',
                        itemStyle: {
                            normal: {
                                areaColor: '#207AC0',
                                borderColor: '#4ecee6',
                                borderWidth: 1,
                                shadowColor: '#2c99f6',
                                shadowOffsetY: 0,
                                shadowBlur: 25
                            }
                        }
                    }, {
                        name: '贵州',
                        itemStyle: {
                            normal: {
                                areaColor: '#207AC0',
                                borderColor: '#4ecee6',
                                borderWidth: 1,
                                shadowColor: '#2c99f6',
                                shadowOffsetY: 0,
                                shadowBlur: 25
                            }
                        }
                    }, {
                        name: '云南',
                        itemStyle: {
                            normal: {
                                areaColor: '#207AC0',
                                borderColor: '#4ecee6',
                                borderWidth: 1,
                                shadowColor: '#2c99f6',
                                shadowOffsetY: 0,
                                shadowBlur: 25
                            }
                        }
                    }, {
                        name: '广西',
                        itemStyle: {
                            normal: {
                                areaColor: '#207AC0',
                                borderColor: '#4ecee6',
                                borderWidth: 1,
                                shadowColor: '#2c99f6',
                                shadowOffsetY: 0,
                                shadowBlur: 25
                            }
                        }
                    }, {
                        name: '海南',
                        itemStyle: {
                            normal: {
                                areaColor: '#207AC0',
                                borderColor: '#4ecee6',
                                borderWidth: 1,
                                shadowColor: '#2c99f6',
                                shadowOffsetY: 0,
                                shadowBlur: 25
                            }
                        }
                    }]
                },
                series: [{
                    name: "",
                    type: "map",
                    geoIndex: 0,
                    data: []
                }]
            },
            //echart data
            dataList: [{
                    name: "北京",
                    value: 540,
                    list: [{
                        company: '北京分公司',
                        address: '北京市大兴区黄村镇清源路40号1幢平房',
                        phone: '010-53792755'
                    }]
                },
                {
                    name: "天津",
                    value: 130,
                    list: []
                },
                {
                    name: "上海",
                    value: 400,
                    list: [{
                        company: '上海分公司',
                        address: '浦东新区航头镇沈杜公路118号2幢104室',
                        phone: '021-58089508',
                    }]
                },
                {
                    name: "重庆",
                    value: 750,
                    list: [{
                        company: '重庆分公司',
                        address: '重庆市九龙坡区石新路220号附1号',
                        phone: '023-68881350',
                    }]
                },
                {
                    name: "河北",
                    value: 130,
                    list: [{
                        company: '河北分公司',
                        address: '河北省石家庄市桥西区振岗路156号石家庄市汽车贸易园桥西区销售中心（南区）D5-B号二层',
                        phone: '0311-68099798',
                    }]
                },
                {
                    name: "河南",
                    value: 830,
                    list: []
                },
                {
                    name: "云南",
                    value: 110,
                    list: [{
                        company: '云南分公司',
                        address: '云南省昆明市五华区二环西路559号',
                        phone: '0871-68327333',
                    }]
                },
                {
                    name: "辽宁",
                    value: 19,
                    list: [{
                        company: '辽宁分公司',
                        address: '辽宁省沈阳市沈河区东陵路36号',
                        phone: '024-88459198'
                    }]
                },
                {
                    name: "黑龙江",
                    value: 150,
                    list: []
                },
                {
                    name: "湖南",
                    value: 690,
                    list: []
                },
                {
                    name: "安徽",
                    value: 60,
                    list: []
                },
                {
                    name: "山东",
                    value: 39,
                    list: [{
                        company: '山东分公司',
                        address: '济宁高新区327国道北、同济大道东东风日产东源专营店',
                        phone: '0537-2989003',
                    }]
                },
                {
                    name: "新疆",
                    value: 4,
                    list: []
                },
                {
                    name: "江苏",
                    value: 31,
                    list: [{
                        company: '江苏分公司',
                        address: '扬州市邗江区荷叶东路160号1',
                        phone: '0514-80971700',
                    }]
                },
                {
                    name: "浙江",
                    value: 104,
                    list: [{
                        company: '浙江分公司',
                        address: '浙江省杭州市拱墅区半山街道北秀街455号（拥铁和光仓储中心）2幢2-2',
                        phone: '0571-56036685',
                    }]
                },
                {
                    name: "江西",
                    value: 36,
                    list: []
                },
                {
                    name: "湖北",
                    value: 52,
                    list: [{
                        company: '湖北分公司',
                        address: '湖北省武汉市蔡甸区沌口小区海天汽配大世界西区29栋158号3楼',
                        phone: '027-84851699',
                    }]
                },
                {
                    name: "广西",
                    value: 33,
                    list: [{
                        company: '广西分公司',
                        address: '柳州市柳南区广西汽车贸易园汇轮路3号柳州航盛航宇汽车销售服务有限公司二楼办公室',
                        phone: '0772-2805355',
                    }]
                },
                {
                    name: "甘肃",
                    value: 7,
                    list: []
                },
                {
                    name: "山西",
                    value: 5,
                    list: [{
                        company: '山西分公司',
                        address: '晋中开发区鸣李汽贸园（汇盛日产汽车服务公司）',
                        phone: '0354-2465335',
                    }]
                },
                {
                    name: "内蒙古",
                    value: 778,
                    list: []
                },
                {
                    name: "陕西",
                    value: 22,
                    list: []
                },
                {
                    name: "吉林",
                    value: 4,
                    list: []
                },
                {
                    name: "福建",
                    value: 18,
                    list: []
                },
                {
                    name: "贵州",
                    value: 5,
                    list: [{
                        company: '贵州分公司',
                        address: '贵州省贵阳市南明区花溪大道北段448号众福家园裙楼半负2层2A号房【湘雅社区】',
                        phone: '0851-83759701',
                    }]
                },
                {
                    name: "广东",
                    value: 98,
                    list: [{
                        company: '广州分公司',
                        address: '广州市天河区博汇街6号3栋110房-1',
                        phone: '020-66357638'
                    }, {
                        company: '深圳分公司',
                        address: '深圳市福田区福田街道福南社区福明路42号福华多层停车库701',
                        phone: '0755-86112327'
                    }, {
                        company: '茂名分公司',
                        address: '茂名市茂南区环市西路文岭村委会12巷1号厂房101室',
                        phone: '0668-33936000'
                    }, {
                        company: '东莞分公司',
                        address: '广东省东莞市南城街道莞太路南城段383号',
                        phone: '0769-22985916'
                    }]
                },
                {
                    name: "青海",
                    value: 1,
                    list: []
                },
                {
                    name: "西藏",
                    value: 0,
                    list: []
                },
                {
                    name: "四川",
                    value: 44,
                    list: [{
                        company: '四川分公司',
                        address: '成都市双流区东升街道龙桥路188号2栋1层1号',
                        phone: '028-85688818',
                    }]
                },
                {
                    name: "宁夏",
                    value: 4,
                    list: []
                },
                {
                    name: "海南",
                    value: 22,
                    list: [{
                        company: '海南分公司',
                        address: '海南省海口市美兰区琼山大道292号东方日产展厅',
                        phone: '0898-65961304',
                    }]
                },
                {
                    name: "台湾",
                    value: 3,
                    list: []
                },
                {
                    name: "香港",
                    list: []
                },
                {
                    name: "澳门",
                    list: []
                },
                {
                    name: "钓鱼岛",
                    list: []
                },
                {
                    name: "赤尾屿",
                    list: []
                },
                {
                    name: "南海诸岛",
                    list: []
                },
            ]
        };
    },
    methods: {
        //初始化中国地图
        initEchartMap() {
            echarts.registerMap('china', dataJson)
            let myChart = echarts.init(this.$refs.echarts)
            myChart.setOption(this.options)
        },
        //修改echart配制
        setEchartOption() {
            this.options.series[0]['data'] = this.dataList;
        }
    },
    created() {
        this.setEchartOption()
    },
    mounted() {
        this.$nextTick(() => {
            this.initEchartMap()
        })

    }
};
</script>

<style lang="less" scoped>
// .echarts-map {
// background: url('../assets/bg_map.png') no-repeat 50% 50%;
// background-size: cover;
// height: 1050px;
// width: 90%;
// background: #114267;
// position: relative;
// }
.echarts-map {
    div {
        width: 100%;
    }
}
// .echarts-map::after {
//     position: absolute;
//     top: 0px;
//     color: #ffffff;
// }

</style>



// WEBPACK FOOTER //
// src/components/ChinaMap.vue